export default __webpack_public_path__ + "static/media/service-3.2e713d9b.jpg";